<template>
  <div class="row">
    <div class="col-xxl-12">
      <div class="module-tabs mb-20">
        <button
          type="button"
          class="module-tab"
          :class="{ active: activeTab === 'products' }"
          @click="selectTab('products')"
        >
          <i class="ph ph-package" aria-hidden="true"></i>
          Produtos
        </button>
        <button
          type="button"
          class="module-tab"
          :class="{ active: activeTab === 'stock' }"
          @click="selectTab('stock')"
        >
          <i class="ph ph-archive-box" aria-hidden="true"></i>
          Estoque
        </button>
        <button type="button" class="module-tab" :class="{ active: activeTab === 'catalog' }" @click="selectTab('catalog')">
          <i class="ph ph-storefront" aria-hidden="true"></i>
          Catálogo
        </button>
      </div>

      <ProductsList v-if="activeTab === 'products'" />
      <ProductStockTab v-else-if="activeTab === 'stock'" />
      <CatalogTab v-else ref="catalogTab" />
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import ProductsList from "../../components/Products/ProductsList.vue";
import ProductStockTab from "../../components/Products/ProductStockTab.vue";
import CatalogTab from "../../components/Products/CatalogTab.vue";

export default defineComponent({
  name: "ProductsPage",
  data() {
    return {
      activeTab: 'products'
    };
  },
  methods: {
    async selectTab(tab: string) {
      if (tab === this.activeTab) return;
      const catalog = this.$refs.catalogTab as { canLeave: () => boolean | Promise<boolean> } | undefined;
      if (this.activeTab === 'catalog' && catalog && !await catalog.canLeave()) return;
      this.activeTab = tab;
    }
  },
  components: {
    ProductsList,
    ProductStockTab,
    CatalogTab
  }
});
</script>

<style scoped>
.module-tabs {
  background: #ffffff;
  border-radius: 7px;
  box-shadow: 0 4px 18px rgba(47, 49, 82, 0.06);
  display: inline-flex;
  gap: 8px;
  padding: 8px;
}

.module-tab {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: #6b7280;
  display: inline-flex;
  font-weight: 600;
  gap: 8px;
  min-height: 42px;
  padding: 0 18px;
  transition: 0.2s ease;
}

.module-tab.active {
  background: #00b894;
  color: #ffffff;
}

@media (max-width: 575.98px) {
  .module-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
  }

  .module-tab {
    justify-content: center;
    padding: 0 10px;
  }
}
</style>
